import {
  Component,
  HostBinding,
  Input,
  OnInit,
  ViewChild
} from "@angular/core";
import { DynamicComponentItem } from "./dynamic-component-item";
import { DynamicComponentDirective } from "./dynamic-component.directive";
import { DynamicComponent } from "./dynamic.component";

@Component({
  selector: "dotcom-frontend-loader",
  templateUrl: "./loader.component.html",
  standalone: true,
  imports: [DynamicComponentDirective]
})
export class LoaderComponent implements OnInit {
  @Input() componentData: DynamicComponentItem | undefined;
  @Input() contentLayout: string | undefined;
  @Input() cssClass: string | undefined;
  @Input() parent: string | undefined;
  @Input() parentBlock: string | undefined;
  @Input() parentSpacing: string | undefined;
  @Input() parentColour!: string;
  @Input() isParentBackgroundColourSet!: boolean;
  @ViewChild(DynamicComponentDirective, { static: true })
  dotcomFrontendDynamicComponent!: DynamicComponentDirective;
  @HostBinding("className") componentClass = "";
  @HostBinding("id") componentId = "";
  @HostBinding("attr.block-type") blockType = "";
  spacingClass = "";

  ngOnInit() {
    this.loadComponent();
    this.addSpacingClass();
    this.addAnchorId();
    this.setImageClass();
    this.setParentBlockType();
  }

  loadComponent() {
    const componentItem = this.componentData;

    if (componentItem && componentItem.component) {
      const viewContainerRef =
        this.dotcomFrontendDynamicComponent.viewContainerRef;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent<DynamicComponent>(
        componentItem.component
      );

      if (this.contentLayout) {
        componentItem.data = {
          ...componentItem.data,
          contentLayout: this.contentLayout
        };
      }

      if (this.parent) {
        componentItem.data = {
          ...componentItem.data,
          parent: this.parent
        };
      }

      if (this.parentSpacing) {
        componentItem.data = {
          ...componentItem.data,
          parentSpacing: this.parentSpacing
        };
      }

      if (this.parentColour) {
        componentItem.data = {
          ...componentItem.data,
          parentColour: this.parentColour
        };
      }

      if (this.isParentBackgroundColourSet) {
        componentItem.data = {
          ...componentItem.data,
          isParentBackgroundColourSet: this.isParentBackgroundColourSet
        };
      }

      componentRef.instance.data = componentItem.data;
    }
  }

  addAnchorId() {
    const componentItem = this.componentData;

    if (componentItem?.data) {
      if (componentItem.data["inPageNavAnchorTitle"]) {
        this.componentId = componentItem.data["inPageNavAnchorTitle"]
          .replace(/\s/g, "")
          .toLowerCase();
      } else if (componentItem.data["contentLink"]) {
        this.componentId = `block-${componentItem.data["contentLink"].id}`;
      }
    }
  }

  addSpacingClass() {
    if (this.parent !== "modal") {
      const componentItem = this.componentData;
      const initialClass = this.cssClass ? this.cssClass : "";

      if (componentItem?.data) {
        const spacingSource = this.parentSpacing
          ? this.parentSpacing
          : componentItem.data["bottomSpacing"];

        switch (spacingSource) {
          case "standard":
            this.spacingClass = " block-spacing";
            break;
          case "zero":
            this.spacingClass = " block-spacing block-spacing--zero";
            break;
          case "half":
            this.spacingClass = " block-spacing block-spacing--half";
            break;
          case "double":
            this.spacingClass = " block-spacing block-spacing--double";
            break;
          default:
            break;
        }

        if (this.parent !== "modal") {
          this.componentClass = `${initialClass}${this.spacingClass}`;
        } else {
          this.componentClass = initialClass;
        }
      }
    }
  }

  setImageClass() {
    const componentItem = this.componentData;
    if (
      componentItem?.data &&
      componentItem.data.contentType &&
      componentItem.data.contentType.includes("Image")
    ) {
      if (this.parentSpacing) {
        this.componentClass = `content-area-image ${this.spacingClass}`;
      } else {
        this.componentClass = "content-area-image";
      }
    }
  }

  setParentBlockType() {
    if (this.parentBlock) {
      this.blockType = this.parentBlock;
    }
  }
}
